module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/suns_sns_05-9b841575a5789292398c9d35ad1b26f6.jpg";